import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
  createRef,
} from "react";
import SearchPanel, {
  ValueChangedEvent,
} from "../../../../../widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData, getNoSlip } from "@shared/utils/CommonUtils";
import { global, useMenuStore, globalMenu } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "@widgets/CommonDialog";
import { fnSave } from "@shared/api/restApi";
import SnResizeBar from "@shared/components/SnResizeBar";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import { showPopupModal, showResizablePopupModal } from "@widgets/CommonModal";
import {
  ExcelUpload_S01_Validate,
  openS02,
  SlipNumberingFn,
  toNonEmptyString,
} from "@menu/XTC/SN_PRD_BAS_REG_001_TEX/excel_upload";
interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;
  [key: string]: any;
}

const SN_PRD_BAS_REG_001_TEX = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo } = global();
  const { menuItems } = useMenuStore();
  const getNoSlipStrict: SlipNumberingFn = async (
    cd_module,
    no_line_tex,
    cd_prefix,
    date,
    cd_menu
  ) =>
    toNonEmptyString(
      await getNoSlip(cd_module, no_line_tex, cd_prefix, date, cd_menu),
      "전표번호가 비어 있습니다."
    );
  const searchRef = useRef<any>(null);
  const formControlDataRef = useRef<any[]>([]);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
  });
  const sheetref1 = useRef<any>(null); // excel download 용
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    sheet1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    sheet1: [],
  });

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
    onExcelUpload,
    onExcelDownLoad,
  }));

  useEffect(() => {
    const fetchForm = async () => {
      try {
        const rtn: any = await getInitFormData();
        const defaultTpItemP = rtn.formData?.tp_item_p ?? "PRD";
        const formControlData = rtn.formControlData.map((control: any) =>
          control.cd_param === "cd_matl"
            ? { ...control, fg_visible: defaultTpItemP === "PRD" ? "N" : "Y" }
            : control
        );
        setFormControlData(formControlData);
        setFormData(rtn.formData);
        const popup_apply = [
          { target: "tp_item_c", source: "tp_item" },
          { target: "dc_item_spec", source: "dc_item_spec" },
          { target: "fg_acct", source: "fg_acct" },
          { target: "nm_model", source: "nm_model" },
        ];
        const grid2 = rtn.grid.grid2.map((col: any) => {
          let newCol = { ...col };
          if (col.cd_column === "cd_matl") {
            newCol.popup_apply = popup_apply;
          }
          return newCol;
        });
        setColums({
          grid1: rtn.grid.grid1,
          grid2: grid2,
          sheet1: rtn.grid.sheet1,
        });
        const param = {
          id: "sn_prd_bas_reg_001_tex_sheet_01",
          // params: { tp_item_c: tp_item_c, no_style: no_style, cd_matl: cd_matl },
          params: rtn.formData,
        };
        const data: any = await fnGetDataSet(param);
        setDataSources({
          grid1: [],
          grid2: [],
          sheet1: data[0],
        });
        //setTpItemC(defaultTpItemC);
      } catch (error) {
        console.log(error);
      }
    };
    fetchForm();
  }, []);

  /* useEffect(() => {
    if (dataSources.grid1.length > 0) {
      const firstRow = dataSources.grid1[0];
      if (firstRow) {
        const { no_style, no_line_bom, tp_item_c } = firstRow;

        gridRefs.current["grid2"].current?.applyFilters({
          no_style,
          no_line_bom,
        });

        gridRefs.current["grid2"].current?.applyPopupConditions({
          cd_matl: { tp_item: tp_item_c },
        });

        gridRefs.current["grid2"].current?.selectAndFocusRow(0);
      }
    }
  }, [dataSources.grid1]);*/

  useEffect(() => {
    formControlDataRef.current = formControlData;
  }, [formControlData]);

  const onSearch = async () => {
    const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
    const modifiedRowsL = gridRefs.current["grid2"].current.getChange();
    if (!searchRef.current.getFormdata().no_style) {
      await showDialog("alter", "스타일 번호가 선택되지 않았습니다.");
      return;
    }

    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const isSaved = await onSave();
        if (!isSaved) return;
      }
    }

    try {
      const param = {
        id: "sn_prd_bas_reg_001_tex_01",
        // params: { tp_item_c: tp_item_c, no_style: no_style, cd_matl: cd_matl },
        params: searchRef.current.getFormdata(),
      };

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      const data: any = await fnGetDataSet(param);
      setDataSources((prev: any) => ({
        ...prev,
        grid1: data[0],
        grid2: data[1] || [],
      }));
    } catch (error: any) {}
  };

  const onInsert = async () => {
    try {
      const searchFormData = searchRef.current?.getFormdata();
      const no_style = searchFormData?.no_style;
      if (!no_style) {
        await showDialog("alter", "스타일 번호가 선택되지 않았습니다.");
        return;
      }

      const maxNoLine =
        gridRefs.current["grid1"].current.getMaxValue("no_line_bom");
      const newRow = {
        cd_firm: userInfo.cd_firm,
        no_style: no_style,
        no_line_bom: maxNoLine + 1,
        nm_bom: maxNoLine + 1,
        cd_user_reg: userInfo.cd_user,
        tp_item_p: searchFormData?.tp_item_p,
        cd_rout: "T20",
      };
      gridRefs.current["grid1"].current?.addRow(newRow);
    } catch (error: any) {}
  };

  const onAddRow = async () => {
    try {
      gridRefs.current["grid1"].current.stopEditing();
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      const rowCount = gridRefs.current["grid1"].current.getDisplayedRowCount();
      if (focusedNodeH == null) {
        await showDialog("alter", "선택된 행이 없습니다.");
        return false;
      } else if (rowCount === 0) {
        await showDialog("alter", "BOM정보를 먼저 추가하시기 바랍니다");
        return false;
      }

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return false;
      }

      const maxNoLine =
        gridRefs.current["grid2"].current.getMaxValue("no_line");
      const newRow = {
        cd_firm: userInfo.cd_firm,
        no_style: focusedNodeH.data?.no_style,
        no_line_bom: focusedNodeH.data?.no_line_bom,
        no_line: maxNoLine + 1,
        cd_matl: "",
        nm_matl: "",
        qt_need: 0,
        cd_rout: focusedNodeH.data.cd_rout,
        cd_op: "T210",
      };
      gridRefs.current["grid2"].current?.addRow(newRow);
    } catch (error: any) {
      throw error;
    }
  };

  const onDelete = async () => {
    if (gridRefs.current["grid1"].current?.getDisplayedRowCount() < 1) return;

    const confirm = await showDialog("confirm", "삭제하시겠습니까?");
    if (!confirm) return;

    gridRefs.current["grid2"].current?.deleteAllRows();
    gridRefs.current["grid1"].current?.deleteSelectedRows();

    const realDeletedRows =
      gridRefs.current["grid1"].current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      // 실제로 삭제된 행이 없으면 변경 사항을 적용하고 반환합니다.
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      return;
    }

    return await onSave();
  };

  const onDeleteRow = async () => {
    if (gridRefs.current["grid2"].current?.getDisplayedRowCount() < 1) return;
    gridRefs.current["grid2"].current?.deleteSelectedRows();
  };

  const onExcelUpload = async () => {
    try {
      const component = (
        <ExcelUpload_S01_Validate
          Menuprops={Menuprops} // 메뉴 정보 전달
          grouping={["no_style", "cd_rout", "nm_bom"]} // 그룹핑할 필드 목록 전달
          onNext={async ({
            validRows,
            headerColumns,
            detailColumns,
            grouping,
          }: {
            validRows: any[];
            headerColumns: any[];
            detailColumns: any[];
            grouping: string[];
          }) => {
            if (!Menuprops.cd_menu) {
              showDialog?.(
                "error",
                "메뉴 코드(Menuprops.cd_menu)가 비어 있습니다."
              );
              return;
            }

            await openS02({
              validRows,
              headerColumns,
              detailColumns,
              grouping,
              controller: "SN_PRD_BAS_REG_001_TEX_SAVE_02",
              numbering: {
                fn: getNoSlipStrict,
                options: {
                  cd_module: "PRD",
                  no_line: 1, //  sys_notescount.no_line 값으로 교체
                  cd_prefix: "BAS",
                  dateField: "tm_reg", // ← 헤더 날짜 '컬럼명'
                  cd_menu: Menuprops.cd_menu,
                },
              },
              upsert: { mode: "create-or-append", allowDelete: false },
              tables: {
                header: "prd_bomh_tex",
                detail: "prd_bom_tex",
              },

              fieldMap: {
                headerNoField: "no_style",
                detailNoField: "no_style",
                lineNoField: "no_line",
              },
            });
          }}
        />
      );

      const result = await showPopupModal({
        title: "제품BOM 엑셀 업로드",
        children: component,
        width: "80%",
        height: "90VH",
        okayBtnText: "다음",
        checkData: false,
      });
      if (result) {
        console.log("엑셀 업로드 완료:", result);
      } else {
        console.log("엑셀 업로드 취소됨");
      }
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  const onExcelDownLoad = async () => {
    try {
      const displayedCols = sheetref1.current?.getAllDisplayedColumns() || [];
      const columnKeys = displayedCols.map((c: any) => c.getColId());

      sheetref1.current?.exportDataAsExcel({
        columnKeys,
        skipPinnedBottom: true,
        fileName: `${globalMenu.getState().activeMenuInfo.nm_menu}.xlsx`,
        sheetName: "Sheet1",
        processCellCallback: (params: any) => {
          if (params.column.getColId() === "yn_std_matl") {
            return params.value ? "Y" : "N";
          }
          return params.value;
        },
      });
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  const onSave = async () => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();
      gridRefs.current["grid2"].current?.stopEditing();

      if (
        !gridRefs.current["grid1"].current?.requiredValuesCheck() ||
        !gridRefs.current["grid2"].current?.requiredValuesCheck()
      )
        return false;
      if (!(await validateStdMatl())) return false;

      const prdBomHTexChanges = gridRefs.current["grid1"].current?.getChange();
      const prdBomLTexChanges = gridRefs.current["grid2"].current?.getChange();

      if (
        prdBomHTexChanges.modifiedRowcount == 0 &&
        prdBomLTexChanges.modifiedRowcount == 0
      ) {
        await showDialog("alter", "저장할 내용이 없습니다.");
        return false;
      }

      prdBomHTexChanges.update =
        prdBomHTexChanges.update?.map((row: any) => ({
          ...row,
          cd_user_amd: userInfo.cd_user,
        })) ?? [];

      const saveData = {
        prd_bomh_tex: prdBomHTexChanges,
        prd_bom_tex: prdBomLTexChanges,
      };

      const ok = await fnSave("SN_PRD_BAS_REG_001_TEX_SAVE_01", saveData);
      if (!ok) return false;

      gridRefs.current["grid1"].current?.resetUpdate();
      gridRefs.current["grid2"].current?.resetUpdate();
      return true;
    } catch (error: any) {
      gridRefs.current["grid1"].current.resetUpdate(true);
      gridRefs.current["grid2"].current.resetUpdate(true);
      return false;
    }
  };
  const onCellValueChanged2 = async (event: CellValueChangedEvent) => {
    if (!event) return;
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    if (colId === "qt_just" || colId === "rt_loss") {
      rowNode.setDataValue(
        "qt_need",
        rowData.qt_just * (1 + rowData.rt_loss / 100),
        "noEvent"
      );
    }
  };
  const onGrid2BtnClick = async (id: string) => {
    try {
      if (id == "addRow") {
        onAddRow();
      }
      if (id == "deleteRow") {
        onDeleteRow();
      }
    } catch (error: any) {
      await showDialog("error", error.message);
    }
  };

  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event;
    if (selectedRow) {
      const no_style = selectedRow.no_style;
      const no_line_bom = selectedRow.no_line_bom;
      gridRefs.current["grid2"].current.applyFilters({
        no_style: no_style,
        no_line_bom: no_line_bom,
      });
      gridRefs.current["grid2"].current.selectAndFocusRow(0);
    } else {
      return;
    }
  };
  const validateStdMatl = async () => {
    const grid = gridRefs.current["grid2"].current;
    if (!grid) return true;

    const matlMap = new Map<string, number>();

    // 🔥 전체 데이터 순회 (필터된 것만)
    grid.forEachFilteredNode((node: any) => {
      const row = node.data;
      if (!row) return;

      const cd_matl = row.cd_matl;
      const isStd = row.yn_std_matl === true || row.yn_std_matl === "Y";

      if (!isStd) return;

      const count = matlMap.get(cd_matl) || 0;
      matlMap.set(cd_matl, count + 1);
    });

    // 🔥 검증
    for (const [cd_matl, count] of matlMap.entries()) {
      if (count > 1) {
        await showDialog(
          "alert",
          "동일 자품목 내에서 기준 소요량 품목은 1개만 지정 가능합니다"
        );
        return false;
      }
    }

    return true;
  };
  const onSearchPanelValueChanged = (event: ValueChangedEvent) => {
    const { colId, newValue } = event;
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged: onFocusedRowChanged,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onBtnAddClick: onGrid2BtnClick,
          onBtnDeleteClick: onGrid2BtnClick,
          onCellValueChanged: onCellValueChanged2,
        },
      },
      sheet1: {
        columns: columns.sheet1,
        dataSource: dataSources.sheet1,
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          onValueChanged={onSearchPanelValueChanged}
        ></SearchPanel>
      </div>
      <div className="flex w-full h-full min-w-0 space-x-1.5">
        <SnResizeBar direction={"width"} id="panel1" orgSize="25.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{
              isEditable: true,
              rowSelection: "multiple",
              title: "BOM정보",
            }}
            events={grids.grid1.events}
          />
        </SnResizeBar>
        <SnResizeBar direction={"width"} id="panel2" orgSize="74%">
          <SnGrid
            ref={gridRefs.current["grid2"]}
            columnConfig={grids.grid2.columns}
            rowData={grids.grid2.dataSource}
            etcProps={{
              isEditable: true,
              rowSelection: "multiple",
              title: "품목정보",
            }}
            events={grids.grid2.events}
          />
        </SnResizeBar>
      </div>
      <div style={{ display: "none" }}>
        <SnGrid
          ref={sheetref1}
          columnConfig={grids.sheet1.columns}
          rowData={grids.sheet1.dataSource} // Datasource
          etcProps={{ isEditable: false }}
        />
      </div>
    </div>
  );
});

export default SN_PRD_BAS_REG_001_TEX;
